import React from 'react';
import gsap from 'gsap';
import TextPlugin from 'gsap/TextPlugin';

class LoadingAnimation extends React.Component {
  componentDidMount() {
    if (typeof window !== `undefined`) {
      gsap.registerPlugin(TextPlugin);
      gsap.core.globals('TextPlugin', TextPlugin);
    }
    const word = '地球上全人類の健康をアップデートさせる。';
    // const word2 = '<br>...<br>';
    // const word3 = '...<br>';
    // const word4 = '... OK,余裕。<br>';
    // const word5 = 'さあ,革命の幕開けだ。';
    let cursor = gsap.to('.textcursor', {
      opacity: 0,
      ease: 'power2.inOut',
      repeat: 20,
    });
    let masterTl = gsap.timeline({}).pause();
    let boxTl = gsap.timeline();

    boxTl.to('.box', {
      onComplete: () => masterTl.play(),
    });

    let tl = gsap.timeline();
    tl.to('.text', { duration: 0.8, text: word });
    masterTl.add(tl);

    // let tl2 = gsap.timeline();
    // tl2.to('.text2', { delay: 0.5, duration: 0.3, text: word2 });
    // masterTl.add(tl2);

    // let tl3 = gsap.timeline();
    // tl3.to('.text3', { duration: 0.3, text: word3 });
    // masterTl.add(tl3);

    // let tl4 = gsap.timeline();
    // tl4.to('.text4', { duration: 0.9, text: word4 });
    // masterTl.add(tl4);

    // let tl5 = gsap.timeline();
    // tl5.to('.text5', { delay: 0.5, duration: 0.9, text: word5 });
    // masterTl.add(tl5);

    // const output = document.querySelector('.message');
    // const underscore = document.querySelector('.underscore');
    // const loadingContainer = document.querySelector('.output-container');
    // window.addEventListener('load', main);
    // async function main() {
    //   await wait(100);
    //   await print('地球上全人類の健康を');
    //   // await wait(250);
    //   await print('アップデートさせる。 ');
    //   await wait(500);
    //   // await print('...', 200);
    //   // await wait(1000);
    //   await print('\n\n...');
    //   await print('\n\n...');
    //   await print('\n\n... OK,余裕。');
    //   await wait(400);
    //   await print('\n\nさあ,革命の幕開けだ。');
    // }
    // async function uno(arg) {
    //   await print(arg);
    // }
    // function print(text, speed = 30) {
    //   return new Promise((resolve) => {
    //     underscore.classList.remove('is-animating');
    //     write(text, speed, 0, resolve);
    //   });
    // }
    // function write(text, speed, i, resolve) {
    //   if (i < text.length) {
    //     output.textContent += text[i];
    //     setTimeout(() => {
    //       write(text, speed, i + 1, resolve);
    //     }, speed);
    //   } else {
    //     underscore.classList.add('is-animating');
    //     resolve();
    //   }
    // }
    // async function dos(arg) {
    //   wait(arg);
    // }
    // function wait(time) {
    //   return new Promise((resolve) => {
    //     setTimeout(() => {
    //       resolve();
    //     }, time);
    //   });
    // }
    //reload set top
    // $(document).ready(function () {
    //   $('html,body').animate({ scrollTop: 0 }, '1');
    // });
    // loading overlay

    gsap.to('.output-container', {
      duration: 1,
      delay: 0.8,
      animation: 'blink 0.1s steps(10) 20',
    });
    gsap.to('.loadingFirst', {
      duration: 2.2,
      delay: 1.5,
      top: '-135%',
      ease: 'expo.inOut',
    });
  }
  render() {
    return (
      <>
        <div className="loadingOverlay loadingFirst">
          <div className="output-container">
            <p className="output">
              {/* <span className="message"></span>
              <span className="underscore is-animating">_</span> */}
              <span class="box"></span>
              <span class="text"></span>
              <span class="text2"></span>
              <span class="text3"></span>
              <span class="text4"></span>
              <span class="text5"></span>
              <span class="textcursor">_</span>
            </p>
          </div>
        </div>
      </>
    );
  }
}

export default LoadingAnimation;
